<template>
  <section class="card">
    <h2 class="section-heading">
      {{ t('sectionE.title') }}
    </h2>
    <div class="legal-text mb-3">
      <p v-html="t('sectionE.text')"></p>
    </div>
    <div class="mt-3">
      <div 
        class="checkbox-grid"
        :class="{ 'is-invalid': formErrors.has('consentToInformation') }"
      >
        <label class="checkbox-card">
          <input
            type="checkbox"
            :checked="modelValue"
            @change="detectChange" 
          />
          <span>{{ t('sectionE.accept') }}</span>
        </label>
      </div>
      <p
        v-if="formErrors.has('consentToInformation')"
        class="error-text"
      >
        {{ t(formErrors.first('consentToInformation')) }}
      </p>
    </div>
  </section>
</template>
<script setup>
  import { reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  const { t } = useI18n();
  defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formErrors:{
      type:Object,
      required:false,
      default:reactive(new Error({}))
    }
  });
  
  const emit = defineEmits(['update:modelValue'])
  const detectChange = (e) => {
    emit('update:modelValue', e.target.checked);
    emit("removeError",'consentToInformation');
  }
  </script>
  <style scoped>
  .checkbox-grid input[type="checkbox"]{
    width: 20px;
    height: 20px;
    min-width: 20px;
    margin-top: 2px; 
    cursor: pointer;
  }
  </style>